import { render } from "./FixedNav.vue?vue&type=template&id=06370958"
import script from "./FixedNav.vue?vue&type=script&lang=js"
export * from "./FixedNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__